'use strict'

function isViewVisibleToUser (component, loggedIn) {

  if (!component || typeof component !== 'object') return false
  if (component.requiresLogin && !loggedIn) return false
  if (component.hideWhenLoggedIn && loggedIn) return false

  return true
}

function componentRequiresLogin (component) {

  return !!(component && component.requiresLogin)
}

function shouldRenderViewForState (component, state) {

  if (state && state.previewMode) return true

  return isViewVisibleToUser(component, state && state.loggedIn)
}

function shouldOfferViewLoginControls (pageBlocksControls, appHasLogin, view) {

  if (pageBlocksControls) return false
  if (appHasLogin) return true

  return !!(view && (view.requiresLogin || view.hideWhenLoggedIn))
}

function componentsIncludeLogin (components) {

  for (const component of components || []) {

    if (!component || typeof component !== 'object') continue
    if (component.type === 'login') return true
    if (componentsIncludeLogin(component.components)) return true
    if (componentsIncludeLogin(component.children)) return true
  }

  return false
}

function pageRequiresLoginFlag (page) {

  return !!(page && (page.requiresLogin === true || page.requiresLogin === 'true'))
}

function ancestorRequiresLogin (page, pages) {

  if (!page || !page.parentUniqueTitle) return false

  const byTitle = new Map()

  for (const item of pages || []) {

    if (item && item.uniqueTitle) byTitle.set(item.uniqueTitle, item)
  }

  const seen = new Set()

  if (page.uniqueTitle) seen.add(page.uniqueTitle)

  let parentTitle = page.parentUniqueTitle

  while (parentTitle) {

    if (seen.has(parentTitle)) return false

    seen.add(parentTitle)

    const parent = byTitle.get(parentTitle)

    if (!parent) return false
    if (pageRequiresLoginFlag(parent)) return true

    parentTitle = parent.parentUniqueTitle
  }

  return false
}

function pageRequiresLogin (page, pages) {

  return pageRequiresLoginFlag(page) || ancestorRequiresLogin(page, pages)
}

function pageIsInLoginProtectedStructure (page, pages) {

  if (!page || !page.parentUniqueTitle) return false

  const byTitle = new Map()

  for (const item of pages || []) {

    if (item && item.uniqueTitle) byTitle.set(item.uniqueTitle, item)
  }

  const seen = new Set()

  if (page.uniqueTitle) seen.add(page.uniqueTitle)

  let parentTitle = page.parentUniqueTitle

  while (parentTitle) {

    if (seen.has(parentTitle)) return false

    seen.add(parentTitle)

    const parent = byTitle.get(parentTitle)

    if (!parent) return false
    if (pageRequiresLoginFlag(parent) || componentsIncludeLogin(parent.components)) return true

    parentTitle = parent.parentUniqueTitle
  }

  return false
}

function nextViewLoginFlags (view, flag) {

  const turningOn = !(view && view[flag])

  if (flag !== 'requiresLogin' && flag !== 'hideWhenLoggedIn') {

    return {
      requiresLogin: !!(view && view.requiresLogin),
      hideWhenLoggedIn: !!(view && view.hideWhenLoggedIn)
    }
  }

  return {
    requiresLogin: flag === 'requiresLogin' ? turningOn : false,
    hideWhenLoggedIn: flag === 'hideWhenLoggedIn' ? turningOn : false
  }
}

function realtimeSubscribeFieldsFrom (routeParams, token) {

  const params = routeParams || {}

  return {
    accountUniqueTitle: params.account || 'default',
    applicationUniqueTitle: params.application,
    token: token || ''
  }
}

module.exports = {
  isViewVisibleToUser,
  componentRequiresLogin,
  shouldRenderViewForState,
  shouldOfferViewLoginControls,
  pageRequiresLoginFlag,
  ancestorRequiresLogin,
  pageRequiresLogin,
  pageIsInLoginProtectedStructure,
  nextViewLoginFlags,
  realtimeSubscribeFieldsFrom
}
